export default __webpack_public_path__ + "static/media/skyship14.37a11a48.webp";